var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-wrapper site-page--not-found"},[_c('div',{staticClass:"site-content"},[_c('h4',{staticClass:"not-found-title"},[_vm._v("╥﹏╥")]),_vm._v(" "),_c('p',{staticClass:"not-found-desc"},[_vm._v("抱歉！获取信息"),_c('em',[_vm._v("失败")]),_vm._v("啦")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73235c4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/error.vue
// module id = null
// module chunks = 